function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37287",
  "data-name": "\\u30D1\\u30B9 37287",
  d: "M0,140.016H4.069A19.571,19.571,0,0,1,4.575,136H1.19A9.751,9.751,0,0,0,0,140.016Z",
  transform: "translate(0 -130.799)",
  fill: "#07abb8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37288",
  "data-name": "\\u30D1\\u30B9 37288",
  d: "M4.069,271H0a9.751,9.751,0,0,0,1.19,4.016H4.575A19.571,19.571,0,0,1,4.069,271Z",
  transform: "translate(0 -260.636)",
  fill: "#07abb8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37289",
  "data-name": "\\u30D1\\u30B9 37289",
  d: "M140.371,140.016V136h-3.456a18.312,18.312,0,0,0-.546,4.016Z",
  transform: "translate(-131.155 -130.799)",
  fill: "#07abb8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37290",
  "data-name": "\\u30D1\\u30B9 37290",
  d: "M162.958,4.054V0c-1.256.351-2.369,1.956-3.1,4.054Z",
  transform: "translate(-153.741)",
  fill: "#07abb8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37291",
  "data-name": "\\u30D1\\u30B9 37291",
  d: "M162.958,410.054V406h-3.1C160.589,408.1,161.7,409.7,162.958,410.054Z",
  transform: "translate(-153.741 -390.473)",
  fill: "#07abb8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37292",
  "data-name": "\\u30D1\\u30B9 37292",
  d: "M271,0V4.054h3.1C273.369,1.956,272.256.351,271,0Z",
  transform: "translate(-260.636)",
  fill: "#07abb8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37293",
  "data-name": "\\u30D1\\u30B9 37293",
  d: "M275,140.016a18.317,18.317,0,0,0-.546-4.016H271v4.016Z",
  transform: "translate(-260.636 -130.799)",
  fill: "#07abb8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37294",
  "data-name": "\\u30D1\\u30B9 37294",
  d: "M140.371,271h-4a18.315,18.315,0,0,0,.546,4.016h3.456Z",
  transform: "translate(-131.155 -260.636)",
  fill: "#07abb8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37295",
  "data-name": "\\u30D1\\u30B9 37295",
  d: "M337.91,14.386h2.973a10.023,10.023,0,0,0-4.807-3.643A11.031,11.031,0,0,1,337.91,14.386Z",
  transform: "translate(-323.224 -10.332)",
  fill: "#07abb8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37296",
  "data-name": "\\u30D1\\u30B9 37296",
  d: "M53.212,406H50.239a10.023,10.023,0,0,0,4.807,3.643A11.031,11.031,0,0,1,53.212,406Z",
  transform: "translate(-48.318 -390.473)",
  fill: "#07abb8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37297",
  "data-name": "\\u30D1\\u30B9 37297",
  d: "M53.212,14.386a11.031,11.031,0,0,1,1.833-3.643,10.023,10.023,0,0,0-4.807,3.643Z",
  transform: "translate(-48.318 -10.332)",
  fill: "#07abb8"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37298",
  "data-name": "\\u30D1\\u30B9 37298",
  d: "M337.911,406a11.031,11.031,0,0,1-1.833,3.643A10.023,10.023,0,0,0,340.885,406Z",
  transform: "translate(-323.225 -390.473)",
  fill: "#07abb8"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37299",
  "data-name": "\\u30D1\\u30B9 37299",
  d: "M271,271v4.016h3.456A18.317,18.317,0,0,0,275,271Z",
  transform: "translate(-260.636 -260.636)",
  fill: "#07abb8"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37300",
  "data-name": "\\u30D1\\u30B9 37300",
  d: "M392.379,136a19.577,19.577,0,0,1,.506,4.016h4.069a9.751,9.751,0,0,0-1.19-4.016Z",
  transform: "translate(-377.373 -130.799)",
  fill: "#07abb8"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37301",
  "data-name": "\\u30D1\\u30B9 37301",
  d: "M271,406v4.054c1.256-.351,2.369-1.956,3.1-4.054Z",
  transform: "translate(-260.636 -390.473)",
  fill: "#07abb8"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "\\u30D1\\u30B9_37302",
  "data-name": "\\u30D1\\u30B9 37302",
  d: "M396.954,271h-4.069a19.572,19.572,0,0,1-.506,4.016h3.385A9.751,9.751,0,0,0,396.954,271Z",
  transform: "translate(-377.373 -260.636)",
  fill: "#07abb8"
});

function SvgWeb(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "world",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.581,
    height: 19.581,
    viewBox: "0 0 19.581 19.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.8180affe.svg";
export { ForwardRef as ReactComponent };